// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchBar_searchInput__S8ff+","filterButton":"SearchBar_filterButton__S0erl"};